import request from '@/utils/request'

export const getMapStock = params => request.get('/accounting/map-stock', { params })

export const getMapStockItem = id => request.get(`/accounting/map-stock/${id}`)

export const getMapStockMovements = params => request.get('/accounting/map-stock-movements', { params })

export const postMapOpening = (id, data) => request.post(`/accounting/map-stock/${id}/opening`, data)

export const postMapPurchase = (id, data) => request.post(`/accounting/map-stock/${id}/purchase`, data)

export const postMapSale = (id, data) => request.post(`/accounting/map-stock/${id}/sale`, data)

export const postMapWriteOff = (id, data) => request.post(`/accounting/map-stock/${id}/write-off`, data)
